import Response from '@/shared/types/response';
import User from '@/shared/types/user';
import fetcher from '@/shared/utils/fetcher';

const getUser = async (auth_token: string) => {
  const token = auth_token;

  try {
    return await fetcher<Response<User[]>>({
      url: '/users',
      method: 'GET',
      token,
    });
  } catch (error) {
    console.error(
      'Error occurred in function "getUser" in file "getUser.ts":',
      error,
    );
    throw error;
  }
};

export default getUser;
